<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    :width="battleType === 1 ? '852px' : '932px'"
    custom-class="team-container"
    @close="handleClose"
  >
    <template #title>
      <div class="modal-title">
        <span>编辑当前回合队伍</span>
      </div>
    </template>
    <div class="team-content">
      <div :class="['left', { union: battleType === 2 }]">
        <div :class="['card', { union: battleType === 2 }]" style="margin-bottom: 16px;">
          <div class="title">
            <span class="dot"></span>
            <span>队伍成员</span>
            <span class="dot"></span>
          </div>
          <div class="flex-line">
            <div v-for="(item, index) in teamLength" :key="item" :class="['flex-item']">
              <div :class="['set-bg', ourTeam[index] ? getItemBg(ourTeam[index]) : '']">
                <img v-if="ourTeam[index]" :src="ourTeam[index].cover_url" alt="" />
              </div>
              <div v-if="ourTeam[index]" class="bottom-info">
                {{ ourTeam[index].name }}
              </div>
              <div v-if="ourTeam[index]" class="mask" @click="handleRemoveOurTeam(index)">移出队伍</div>
            </div>
          </div>
        </div>
        <div :class="['card', 'pet', { union: battleType === 2 }]">
          <div class="title">
            <span class="dot"></span>
            <span>本回合召唤物</span>
            <span class="dot"></span>
          </div>
          <div class="flex-summons">
            <div v-for="(item, index) in summonsLength" :key="item" class="flex-item">
              <div v-if="petsTeam[index]" class="mask" @click="handleRemovePet(index)">移出队伍</div>
              <div v-if="petsTeam[index]" class="bottom-info">
                {{ petsTeam[index].name }}
              </div>
              <img v-if="petsTeam[index]" :src="petsTeam[index].icon" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="search">
          <input placeholder="请输入角色名称" v-model="keyword" type="text" />
        </div>
        <div class="content">
          <div class="role-box">
            <div
              v-for="item in filterRoleList"
              :key="item.id"
              :class="['role-item', getItemBg(item)]"
              @click="handleAddRole(item)"
            >
              <div class="bottom-info">
                {{ item.name }}
              </div>
              <img v-if="item.type === 'role'" :src="item.icon_1" alt="" />
              <img v-else-if="item.type === 'pet'" :src="item.icon" alt="" />
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="tab-box">
            <div
              v-for="item in enemyArr"
              :key="item.val"
              :class="['tab-item', 'level', activeStar === item.val ? 'active' : '']"
              @click="handleItem(item)"
            >
              {{ item.label }}
            </div>
          </div>
          <div class="tab-box">
            <div
              v-for="item in propertyArr"
              :key="item.val"
              :class="['tab-item', 'property', activeProperty === item.val ? 'active' : '']"
              @click="handlePropertyItem(item)"
            >
              <img :src="item.url" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { createUniqueKey } from "@/plugins/util";

export default {
  props: {
    current: {
      type: Object,
      default: () => ({})
    },
    roleList: {
      type: Array,
      default: () => []
    },
    // 1 一般，2 工会
    battleType: {
      type: Number,
      default: 1
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val && this.current) {
          if (this.current.ourSortData) {
            this.current.ourSortData.forEach(item => {
              if (item.type === "role") {
                this.ourTeam.push({
                  ...item,
                  uniqueKey: item.uniqueKey || createUniqueKey()
                });
              } else {
                this.petsTeam.push({
                  ...item,
                  uniqueKey: item.uniqueKey || createUniqueKey()
                });
              }
            });
          }
        }
      }
    }
  },
  data() {
    return {
      visible: false,
      keyword: "",
      ourTeam: [],
      petsTeam: [],
      enemyArr: [
        { val: "5星", label: "5 ★" },
        { val: "4星", label: "4 ★" },
        { val: "3星", label: "3 ★" },
        { val: "pet", label: "召唤物" }
      ],
      propertyArr: [
        { val: "火", url: require("@/assets/zs_imgs/battle/huo.png"), label: "火" },
        { val: "水", url: require("@/assets/zs_imgs/battle/shui.png"), label: "水" },
        { val: "风", url: require("@/assets/zs_imgs/battle/feng.png"), label: "风" },
        { val: "光", url: require("@/assets/zs_imgs/battle/guang.png"), label: "光" },
        { val: "暗", url: require("@/assets/zs_imgs/battle/an.png"), label: "暗" }
      ],
      activeStar: "",
      activeType: 1,
      activeProperty: ""
    };
  },
  computed: {
    teamLength() {
      return this.battleType === 1 ? 5 : 7;
    },
    summonsLength() {
      return this.battleType === 1 ? 7 : 25;
    },
    filterRoleList() {
      let result = JSON.parse(JSON.stringify(this.roleList));
      if (this.ourTeam && this.ourTeam.length) {
        // 先过滤掉召唤物
        const noPets = this.ourTeam.filter(item => item.star !== "pet");
        // 过滤已经选择了的角色
        result = result.filter(item => !noPets.some(role => role.id === item.id));
      }
      if (this.activeStar) {
        result = result.filter(item => item.star === this.activeStar);
      }
      if (this.activeProperty) {
        result = result.filter(item => item.attr === this.activeProperty);
      }
      if (this.keyword) {
        result = result.filter(item => item.name.includes(this.keyword));
      }
      // 根据星级排序
      result.sort((a, b) => {
        return Number(b.star) - Number(a.star);
      });
      return result;
    }
  },
  methods: {
    // 获取背景
    getItemBg(data) {
      if (data.attr === "火") {
        return "red";
      } else if (data.attr === "光") {
        return "yellow";
      } else if (data.attr === "水") {
        return "blue";
      } else if (data.attr === "暗") {
        return "purple";
      } else if (data.attr === "风") {
        return "green";
      }
      return "";
    },
    // 选择星级
    handleItem(item) {
      if (this.activeStar === item.val) {
        this.activeStar = "";
        return;
      }
      this.activeStar = item.val;
    },
    // 选择属性
    handlePropertyItem(item) {
      if (this.activeProperty === item.val) {
        this.activeProperty = "";
        return;
      }
      this.activeProperty = item.val;
    },
    // 添加角色
    handleAddRole(item) {
      const allLength = this.ourTeam.length + this.petsTeam.length;
      if (this.battleType === 1) {
        if (allLength > 12) {
          this.$message.warning("队伍成员已满");
          return;
        }
      } else {
        if (allLength > 25) {
          this.$message.warning("队伍成员已满");
          return;
        }
      }
      if (item.type === "pet") {
        if (this.petsTeam.length >= this.summonsLength) {
          this.$message.warning("召唤物已满");
          return;
        }
        this.petsTeam.push({
          ...item,
          actionType: "skills",
          cover_url: item.icon,
          uniqueKey: createUniqueKey()
        });
        return;
      } else {
        if (this.ourTeam.length >= this.teamLength) {
          this.$message.warning("队伍成员已满");
          return;
        }
        // 默认取第一个皮肤
        const currentSkin = item.skin[0];
        // 默认潜力
        // const currentPotential = (currentSkin.skills && [currentSkin.skills.potential[0]]) || [];
        const currentPotential = null;
        // 默认强化
        // const currentStrengthen = currentSkin.skills && currentSkin.skills.strengthen[0];
        const currentStrengthen = null;
        let sp = 0;
        let cd = 0;
        if (currentPotential) {
          sp += Number.isNaN(Number(currentPotential.sp)) ? 0 : Number(currentPotential.sp);
          cd += Number.isNaN(Number(currentPotential.cd)) ? 0 : Number(currentPotential.cd);
        }
        if (currentStrengthen) {
          sp += Number.isNaN(Number(currentStrengthen.sp)) ? 0 : Number(currentStrengthen.sp);
          cd += Number.isNaN(Number(currentStrengthen.cd)) ? 0 : Number(currentStrengthen.cd);
        }
        this.ourTeam.push({
          ...item,
          sp,
          cd,
          actionType: "skills",
          currentSkin,
          currentPotential,
          currentStrengthen,
          cover_url: item.icon_1,
          uniqueKey: createUniqueKey()
        });
      }
    },
    // 移出角色
    handleRemoveOurTeam(index) {
      this.ourTeam.splice(index, 1);
    },
    // 移除宠物
    handleRemovePet(index) {
      this.petsTeam.splice(index, 1);
    },
    handleClose() {
      console.log("close");
      this.visible = false;
      const result = [];
      this.ourTeam.forEach(item => {
        result.push({
          ...item
        });
      });
      this.petsTeam.forEach(item => {
        result.push({
          ...item
        });
      });
      this.$emit("updateTeam", JSON.parse(JSON.stringify(result)));
      this.ourTeam = [];
      this.petsTeam = [];
    }
  }
};
</script>
<style lang="less">
@import "./common.less";

.team-container {
  background: linear-gradient(180deg, #cec1b5 0%, #a29a92 100%);
  .el-dialog__header {
    display: flex;
    align-items: center;
    height: 57px;
    padding: 0 20px;
    color: #333;
    font-size: 18px;
    font-weight: 600;
    .modal-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      i {
        cursor: pointer;
        font-weight: 500;
        font-size: 20px;
      }
    }
  }
  .el-dialog__body {
    padding: 0 11px 11px;
    .team-content {
      display: flex;
      height: 550px;
      .left {
        display: flex;
        flex-direction: column;
        width: 322px;
        height: 100%;
        margin-right: 12px;
        overflow: hidden;
        &.union {
          width: 400px;
        }
        .card {
          flex: 0 0 auto;
          padding: 16px 13px;
          background-color: #fff;
          border-radius: 8px;
          &.union {
            padding: 16px 12px;
            .flex-summons {
              gap: 7px;
              .flex-item {
                width: 66px;
                height: 66px;
              }
            }
          }
          &.pet {
            flex: 1;
            overflow: auto;
          }
          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0 17px;
            margin-bottom: 16px;
            height: 32px;
            box-sizing: border-box;
            border-radius: 16px;
            background-color: rgba(182, 169, 151, 0.6);
            color: #5a4434;
            font-size: 14px;
            font-weight: 500;
            .dot {
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background: rgba(90, 68, 52, 0.6);
            }
          }
          .flex-line {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 8px;
            .flex-item {
              position: relative;
              width: 83px;
              height: 107px;
              border-radius: 8px;
              background-color: rgba(210, 202, 197, 0.46);
              box-shadow: inset 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
              border: 1px solid rgba(178, 167, 160, 0.46);
              box-sizing: border-box;
              &:hover {
                .mask {
                  opacity: 1;
                }
              }
              .bottom-info {
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 24px;
                color: #fff;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
                border-radius: 0 0 8px 8px;
              }
              .set-bg {
                position: absolute;
                top: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                overflow: hidden;
                border-radius: 8px;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 8px;
                }
              }
              .mask {
                position: absolute;
                top: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                opacity: 0;
                color: #fff;
                font-size: 12px;
                background-color: rgba(0, 0, 0, 0.3);
                transition: all 0.3s;
                cursor: pointer;
              }
            }
          }
          .flex-summons {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 8px;
            .flex-item {
              position: relative;
              width: 68px;
              height: 68px;
              border-radius: 8px;
              background-color: rgba(210, 202, 197, 0.46);
              box-shadow: inset 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
              border: 1px solid rgba(178, 167, 160, 0.46);
              &:hover {
                .mask {
                  opacity: 1;
                }
              }
              .bottom-info {
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 24px;
                color: #fff;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
                border-radius: 0 0 8px 8px;
              }
              .mask {
                position: absolute;
                top: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                opacity: 0;
                color: #fff;
                font-size: 12px;
                background-color: rgba(0, 0, 0, 0.3);
                transition: all 0.3s;
                cursor: pointer;
              }
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 8px;
              }
            }
          }
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;
        padding: 12px 16px;
        background-color: #fff;
        border-radius: 8px;
        box-sizing: border-box;
        overflow: hidden;
        .search {
          flex: 0 0 auto;
          width: 100%;
          height: 40px;
          margin-bottom: 18px;
          padding: 10px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #dcdcdc;
          input {
            width: 100%;
            border: none;
            outline: none;
            color: #333;
            &::placeholder {
              color: #999;
            }
          }
        }
        .content {
          flex: 1;
          overflow: auto;
          margin-bottom: 16px;
          .role-box {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            .role-item {
              position: relative;
              width: 83px;
              height: 107px;
              border-radius: 8px;
              overflow: hidden;
              // background-color: rgba(210, 202, 197, 0.46);
              cursor: pointer;
              .bottom-info {
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 24px;
                color: #fff;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                // background-color: #665f5d;
                border-radius: 0 0 8px 8px;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
              }
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
        .footer {
          flex: 0 0 auto;
          display: flex;
          flex: 0 0 auto;
          height: 40px;
          .tab-box {
            display: flex;
            align-items: center;
            height: 100%;
            padding: 4px;
            margin-right: 12px;
            border-radius: 4px;
            background-color: #ece6e0;
            box-sizing: border-box;
            .tab-item {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
              padding: 0 14px;
              cursor: pointer;
              color: #967a5f;
              font-size: 13px;
              border-radius: 4px;
              &.property {
                width: 32px;
                height: 32px;
                margin-right: 10px;
                padding: 0;
                &:last-child {
                  margin-right: 0;
                }
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              &.level {
                font-size: 14px;
              }
              &.active {
                background-color: #967a5f;
                color: #fff;
              }
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>
